import { connect } from 'react-redux';
import {
  requestProductDetail,
  requestCreateProductOffers,
  createSavingGoal,
  requestPaymentSchedule,
  requestCheckoutDetail,
  requestGenerateCheckoutPaymentSip
} from 'src/redux/actions';
import SipTransactions from './sipTransactions';

function mapStateToProps(state) {
  return {
    productDetail: state.product.productDetail,
    credentials: state.credentials,
    savingPlan: state.savingPlan,
    savingGoals: state.savingGoals,
    checkout: state.checkout,
  };
}

export default connect(mapStateToProps, {
  requestProductDetail,
  requestCreateProductOffers,
  createSavingGoal,
  requestPaymentSchedule,
  requestCheckoutDetail,
  requestGenerateCheckoutPaymentSip
})(SipTransactions);
